import { jsxs, jsx } from "react/jsx-runtime";
const IconDocumentSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M14 11H9a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2Zm-2 4H9a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2Z" }),
      /* @__PURE__ */ jsx("path", { d: "M19.414 7 15 2.586A2.014 2.014 0 0 0 13.586 2H7C5.346 2 4 3.346 4 5v14c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8.414c0-.526-.214-1.042-.586-1.414Zm-2.828 0H16a1 1 0 0 1-1-1v-.586L16.586 7ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6v2c0 1.654 1.346 3 3 3h2v10Z" })
    ]
  }
);
export {
  IconDocumentSvg
};
